import { LogOut } from 'lucide-react'
import ACCA from "../../assets/ACCA.png"
import { Link } from 'react-router-dom'

const EndingScreen = () => {
  return (
    <>
    <div>
        <div className="py-4 bg-[#DCDDDD] px-3 flex items-center justify-between">
            <h1 className="font-bold text-sm">
                Diploma in International Financial Reporting (IFR - INT) Sample Questions - June 2024
            </h1>
        </div>
        <div className="py-5 bg-[#F2F2F2]" />

    </div>
    <div className="max-h-[calc(100vh_-_132px)] h-full p-5 bg-white">
        <img src={ACCA} alt="" />
        <h1 className="font-semibold mt-8">Your exam is now complete.</h1>
        <p className="my-10">You can resit this exam at any time</p>
        <p className="mb-16">You can access additional learning support resources at <Link className="font-bold text-secondary" to={'/'}>https://www.nilewisect.com</Link></p>
        <p>Select <span className="font-semibold">Exit</span></p>

    </div>
    <div className="flex justify-between bg-[#DCDDDD] px-3">
        <Link
            to={'/'}
            className="font-bold text-sm flex items-center gap-1 py-2 pr-2 border-r border-white hover:text-secondary duration-300 transition-all"
        >
            <LogOut size={16} /> Exit
        </Link>


    </div>
</>
)
}

export default EndingScreen